import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Overflow16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.5 8C3.5 8.55228 3.05228 9 2.5 9C1.94772 9 1.5 8.55228 1.5 8C1.5 7.44772 1.94772 7 2.5 7C3.05228 7 3.5 7.44772 3.5 8Z'
      fill='currentColor'
    />
    <path
      d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z'
      fill='currentColor'
    />
    <path
      d='M13.5 9C14.0523 9 14.5 8.55228 14.5 8C14.5 7.44772 14.0523 7 13.5 7C12.9477 7 12.5 7.44772 12.5 8C12.5 8.55228 12.9477 9 13.5 9Z'
      fill='currentColor'
    />
  </Svg>
);

Overflow16.displayName = 'Overflow16';
export default Overflow16;
